module.exports = __webpack_public_path__ + "static/BoulderValley40under40.c0672cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/press-logos/BoulderValley40under40.png
// module id = 1054
// module chunks = 213534597649335